
















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSPagination, { PaginationModel } from './AMSPagination.vue';
import AMSTable from './AMSTableTitle.vue';
import request from '@/utils/request';
import { getModuleName } from '@/utils/utils';
@Component({
  components: {
    'ams-pagination': AMSPagination,
    'ams-table': AMSTable
  }
})
export default class AMSformTable extends Vue {
  public $refs!: {
    amstable: HTMLElement;
  };
  pagination: PaginationModel = {
    sortBy: '',
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 20, 30, 40]
  };
  list: any = [];
  otherData: object = {};
  @Prop() api?: string;
  @Prop() form?: object;
  @Prop() headers?: Array<object>;
  @Prop() beforeQuery?: Function;

  created() {
    this.query();
  }
  checkedAll() {
    (this.$refs.amstable as HTMLFormElement).toggleAll();
  }
  clear() {
    this.$emit('clearForm');
  }
  clearSelected() {
    (this.$refs.amstable as HTMLFormElement).clearSeleted();
  }
  query(isHandle = false) {
    if (isHandle) {
      if (this.beforeQuery) {
        this.beforeQuery();
      }
      this.pagination.page = 0;
    }
    let param = Object.assign({}, this.form, {
      skipCount: this.pagination.page * this.pagination.rowsPerPage,
      maxResultCount: this.pagination.rowsPerPage,
      sorting: this.pagination.sortBy
    });
    localStorage.setItem(`${getModuleName(this.$route.name as string)}_page`, '');
    localStorage.setItem(`${getModuleName(this.$route.name as string)}_search`, '');
    localStorage.setItem(`${getModuleName(this.$route.name as string)}_search`, JSON.stringify(this.form));
    localStorage.setItem(`${getModuleName(this.$route.name as string)}_page`, JSON.stringify(this.pagination));
    request.get(this.api!, param).then((data: any) => {
      let titleList: any = [];
      if (data.allocationList) {
        data.allocationList.items.forEach((order: any) => {
          order.isOrder = true;
          titleList.push(order);
          let items = order.items;
          if (items) {
            items.forEach((item: any) => {
              titleList.push(item);
            });
          }
        });
      }
      this.list = titleList;
      // this.pagination.totalItems = data.totalCount;
      this.pagination.totalItems = data.allocationList.totalCount;
      this.otherData = {
        customerOrderCount: data.customerOrderCount,
        materialOrderCount: data.materialOrderCount,
        totalCount: data.totalCount
      };
    });
  }
  onPageChange(page: number) {
    this.pagination.page = page;
    this.query();
  }
  onPageSizeChange(size: number) {
    this.pagination.rowsPerPage = size;
    this.query();
  }
  @Watch('otherData')
  changeOtherData(val: any) {
    this.otherData = val;
    this.$emit('getOtherData', this.otherData);
  }

  btnClick(btn: any, index: number, key: string) {
    this.$emit('btnClick', btn, index, key);
  }

  selectedAll(value: Array<any>) {
    this.$emit('selectedAll', value);
  }
  sortByItem(value: string) {
    if (value) {
      this.pagination.sortBy = value;
      this.query();
    }
  }
}
